"use client";

import { Badge } from "@workspace/ui/components/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@workspace/ui/components/select";

interface EnumFieldProps {
  value?: string;
  options: string[];
  editing?: boolean;
  onChange?: (value: string) => void;
}

export function EnumField({
  value,
  options,
  editing,
  onChange,
}: EnumFieldProps) {
  if (!editing) {
    return value ? (
      <Badge variant="outline" className="text-sm px-2 py-0.5 font-normal">
        {value}
      </Badge>
    ) : (
      <span className="text-sm text-muted-foreground italic">—</span>
    );
  }

  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger className="h-8 text-sm w-auto min-w-[100px]">
        <SelectValue placeholder="Select..." />
      </SelectTrigger>
      <SelectContent>
        {options.map((opt) => (
          <SelectItem key={opt} value={opt} className="text-sm">
            {opt}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
